function objectify (keys, values) {
  const length = Math.min(keys.length, values.length)
  const object = {}
  for (let index = 0; index < length; index++) {
    const key = keys[index]
    const value = values[index]
    object[key] = value
  }
  return object
}

function filterFirstRow (_, index) {
  return index > 0
}

function filterEmptyRows (row) {
  return row.trim()
}

function restoreQuotedContent (replacements, _, capture) {
  const index = parseFloat(capture) - 1
  return replacements[index]
}

function replaceQuotedContent (replacements, _, capture) {
  return `-_>_>_>_-${replacements.push(capture)}-_<_<_<_-`
}

function mapColumn (replacements, column) {
  return column
    .trim()
    .replace(/-_>_>_>_-([0-9]+)-_<_<_<_-/, restoreQuotedContent.bind(undefined, replacements))
}

function mapRow (options, row) {
  const replacements = []
  return row
    .replace(/(?:['"])(.*?)"/g, replaceQuotedContent.bind(undefined, replacements))
    .split(options.columnSeparator)
    .map(mapColumn.bind(undefined, replacements))
}

function mapRowIntoObject (keys, values) {
  return objectify(keys, values)
}

function parse (text, options) {
  const {
    rowSeparator,
    columnSeparator,
    useFirstRow
  } = {
    rowSeparator: '\n',
    columnSeparator: ',',
    useFirstRow: false,
    ...options
  }
  const rows = text
    .split(rowSeparator)
    .filter(filterEmptyRows)
    .map(mapRow.bind(undefined, {
      columnSeparator
    }))
  if (useFirstRow) {
    const [keys] = rows
    return rows
      .filter(filterFirstRow)
      .map(mapRowIntoObject.bind(undefined, keys))
  }
  return rows
}

export default {
  parse
}
